export default {
  title: 'Promowane produkty',
};
